import {createSlice} from "@reduxjs/toolkit"
import { add } from "date-fns"


const InitialState = {
    employee:[]
}

export const employeesSlice = createSlice({
    name:"employee",
    initialState:InitialState,
    reducers:{
        addAllemployees:(state,action)=>{
            state.employee = action.payload
        },
        addemployee:(state,action)=>{
            state.employee.push(action.payload)
        },
        updateemployee: (state, action) => {
  const updatedemployee = action.payload;
  const employeeIndex = state.employee.findIndex(employee => employee._id === updatedemployee._id);
  if (employeeIndex !== -1) {
    state.employee[employeeIndex] = {
      ...state.employee[employeeIndex],
      ...updatedemployee
    };
  }
}
    }
})



export const {addAllemployees,addemployee,updateemployee} = employeesSlice.actions

export default employeesSlice.reducer